<div class="nova-wrapper">
  @if (iframeSrc) {
    <iframe #frame (load)="onFrameLoad()" class="nova-iframe w-100 h-100" [src]="iframeSrc | safeHtml" frameborder="0" allow="camera *;microphone *;display-capture *;fullscreen *"></iframe>
  }
</div>